module.exports = __webpack_public_path__ + "static/img/log-active.24e18f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/log-active.png
// module id = OXQ0
// module chunks = 58